import 'bootstrap';
import 'slick-carousel';
import '../vendor/lightgallery/lightgallery';
import '../vendor/lightgallery/lg-video';
import '../vendor/lightgallery/lg-thumbnail';

import YouTubePlayer from './youtube-player';

const $win = $(window);
const $doc = $(document);

//  Internet Explorer fix for background attachment fixed bug
if (navigator.userAgent.match(/Trident\/7\./)) {
	document.body.addEventListener('mousewheel', function() {
		event.preventDefault();
		var wd = event.wheelDelta;
		var csp = window.pageYOffset;
		window.scrollTo(0, csp - wd);
	});
}

//  Add Padding to wrapper for fixed header space

const $fixedHeader = $('.header.fixed-top');
const $stickyHeader = $('.header--sticky');
const $introSlide = $('.slider--intro .slider__slide');
const introSlideHeight = $introSlide.height();

$win.on('load resize', () => {
	const fixedHeaderHeight = $fixedHeader.height();
	const stickyHeaderHeight = $stickyHeader.height();

	if ($fixedHeader) {
		$('.wrapper').css('padding-top', fixedHeaderHeight);
	}

	if ($stickyHeader) {
		$introSlide.height(introSlideHeight + stickyHeaderHeight);
		$('.intro .intro__content').css('padding-top', stickyHeaderHeight);
	}
});

const $parallax = $('.js-parallax');

$win.on('load resize scroll', function() {
	var winScrollTop = $win.scrollTop();

	parallax($parallax, winScrollTop);
});

//  Parallax Background
function parallax($elements, scrollTop) {
	$elements.each(function() {
		const $this = $(this);
		const $parent = $this.parent();
		const modifier = 0.2;
		const winWidth = $win.width();
		const winHeight = $win.height();
		const offset = $parent.offset().top;

		if (
			offset < scrollTop + winHeight &&
			offset + $parent.outerHeight() > scrollTop
		) {
			$this.css({
				transform: `translate3d(0, ${(scrollTop - offset) *
					modifier}px, 0)`,
				height: $parent.height() + $parent.height() * modifier
			});
		}
	});
}

//  Initialize Sliders

const $homeSlider = $('.js-slider-home');
const $homeSlides = $homeSlider.find('.slider__slides');

$homeSlides.on('init', function(slick) {
	$(this)
		.find('.slick-current')
		.addClass('active');
});

$homeSlides.slick({
	fade: $homeSlider.data('fade'),
	slidesToShow: 1,
	speed: $homeSlider.data('speed') ? $homeSlider.data('speed') * 1000 : 1000,
	draggable: false,
	cssEase: 'ease-in-out',
	autoplaySpeed: $homeSlider.data('autoplay-speed')
		? $homeSlider.data('autoplay-speed') * 1000
		: 8000,
	arrows: false,
	autoplay: true,
	dots: true,
	infinite: true,
	pauseOnHover: false
});

$homeSlides.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	var addIndex = $homeSlider.data('fade') ? 0 : 1;
	setTimeout(function() {
		$homeSlides
			.find('.slick-slide')
			.eq(currentSlide + addIndex)
			.removeClass('active');
	}, 1000);

	$homeSlides
		.find('.slick-slide')
		.eq(nextSlide + addIndex)
		.addClass('active');
});

//  Single Item

$('.js-slider-single-item .slider__slides').slick({
	fade: true,
	arrows: false,
	autoplay: true,
	dots: true,
	infinite: true
});

//  Two Items

$('.js-slider-two-items .slider__slides').slick({
	slidesToShow: 2,
	sldesToScroll: 1,
	nextArrow: $('.js-slider-two-items .slider__next'),
	prevArrow: $('.js-slider-two-items .slider__prev'),
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});

//  Three Items

var $threeItemsSlider = $('.js-slider-three-items .slider__slides');

$threeItemsSlider.on('init', function(slick) {
	setTimeout(function() {
		$threeItemsSlider.find('.slick-active .update__entry').equalizeHeight();
	}, 10);
});

$threeItemsSlider.slick({
	slidesToShow: 3,
	sldesToScroll: 1,
	nextArrow: $('.js-slider-three-items .slider__next'),
	prevArrow: $('.js-slider-three-items .slider__prev'),
	responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 576,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});

$threeItemsSlider.on('afterChange', function(
	event,
	slick,
	currentSlide,
	nextSlide
) {
	$(this)
		.find('.slick-active .update__entry')
		.equalizeHeight();
});

$win.on('load resize', function() {
	$threeItemsSlider.find('.slick-active .update__entry').equalizeHeight();
});

//  Product Images

const $sliderProductImagesHolder = $('.js-slider-product-images');
const $sliderProductImages = $sliderProductImagesHolder.find('.slider__slides');

$sliderProductImages
	.slick({
		fade: true,
		arrows: true,
		autoplay: false,
		infinite: true,
		adaptiveHeight: false,
		dots: true,
		nextArrow: $('.js-slider-product-images .slider__next'),
		prevArrow: $('.js-slider-product-images .slider__prev'),
		asNavFor: '.js-product-thumbs',
		customPaging: function(slick) {
			$sliderProductImagesHolder
				.find('.slider__status-current')
				.text(slick.currentSlide + 1);

			$sliderProductImagesHolder
				.find('.slider__status-total')
				.text(slick.slideCount);
		}
	})
	.on('afterChange', function(event, slick, currentSlide) {
		slick.options.customPaging.call(this, slick, currentSlide);
	});

$('.js-product-thumbs').slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	arrows: false,
	variableWidth: true,
	asNavFor: $sliderProductImages,
	focusOnSelect: true
});

//  Initialize AnimateCss Slider

const $animateSlider = $('.js-slider-animate-css');
const $animateSlides = $animateSlider.find('.slider__slides');
const animationsArr = [
	'bounce',
	'flash',
	'pulse',
	'rubberBand',
	'shake',
	'headShake',
	'swing',
	'tada',
	'wobble',
	'jello',
	'bounceIn',
	'bounceInDown',
	'bounceInLeft',
	'bounceInRight',
	'bounceInUp',
	'fadeIn',
	'fadeInDown',
	'fadeInDownBig',
	'fadeInLeft',
	'fadeInLeftBig',
	'fadeInRight',
	'fadeInRightBig',
	'fadeInUp',
	'fadeInUpBig',
	'flipInX',
	'flipInY',
	'lightSpeedIn',
	'rotateIn',
	'rotateInDownLeft',
	'rotateInDownRight',
	'rotateInUpLeft',
	'rotateInUpRight',
	'jackInTheBox',
	'rollIn',
	'zoomIn',
	'zoomInDown',
	'zoomInLeft',
	'zoomInRight',
	'zoomInUp',
	'slideInDown',
	'slideInLeft',
	'slideInRight',
	'slideInUp',
	'heartBeat'
];

function getRandomAnimation(arr) {
	return arr[Math.floor(Math.random() * arr.length)];
}

$animateSlides.on('init', function(e, slick) {
	let $firstAnimatingElements = $animateSlides.find(
		'.slick-slide:first-child [data-animation]'
	);
	doAnimations($firstAnimatingElements);
});

$animateSlides.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
	let $animatingElements = $animateSlides
		.find('.slick-slide[data-slick-index="' + nextSlide + '"]')
		.find('[data-animation]');
	doAnimations($animatingElements);
});
$animateSlides.slick({
	fade: $animateSlider.data('fade'),
	speed: $animateSlider.data('speed')
		? $animateSlider.data('speed') * 1000
		: 1000,
	draggable: false,
	cssEase: 'ease-in-out',
	autoplaySpeed: $animateSlider.data('autoplay-speed')
		? $animateSlider.data('autoplay-speed') * 1000
		: 8000,
	arrows: false,
	autoplay: true,
	dots: true,
	infinite: true,
	pauseOnHover: false
});

function doAnimations(elements) {
	let animationEndEvents =
		'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

	elements.each(function() {
		const $this = $(this);
		let $animationDelay = $this.data('delay');
		let $animationType =
			'animated ' +
			($this.data('animation') === 'random'
				? getRandomAnimation(animationsArr)
				: $this.data('animation'));
		$this.css({
			'animation-delay': $animationDelay,
			'-webkit-animation-delay': $animationDelay
		});

		$this.addClass($animationType).one(animationEndEvents, function() {
			$this.removeClass($animationType);
		});
	});
}

//  Initialize Simple Images slider

const $imageSlider = $('.js-slider-simple-images');
const $imageSlides = $imageSlider.find('.slider__slides');

$imageSlides.slick({
	fade: $imageSlider.data('fade'),
	slidesToShow: 1,
	speed: $imageSlider.data('speed')
		? $imageSlider.data('speed') * 1000
		: 1000,
	draggable: false,
	cssEase: 'ease-in-out',
	autoplaySpeed: $imageSlider.data('autoplay-speed')
		? $imageSlider.data('autoplay-speed') * 1000
		: 8000,
	arrows: false,
	autoplay: true,
	dots: false,
	infinite: true,
	pauseOnHover: false,
	adaptiveHeight: true
});

//  Initialize Logo Scroller slider

const $logoScrollers = $(
	'.list-manifacturer-logos-scroller[data-autoplay=true]'
);

$logoScrollers.each(function() {
	const $logoScroller = $(this);

	$logoScroller.slick({
		slidesToShow: 1,
		speed: $logoScroller.data('scroll-speed')
			? $logoScroller.data('scroll-speed') * 1000
			: 3000,
		draggable: false,
		cssEase: 'linear',
		autoplay: true,
		autoplaySpeed: 0,
		arrows: false,
		draggable: false,
		dots: false,
		infinite: true,
		pauseOnHover: false,
		variableWidth: true
	});
});

// Rating Checkboxes

const $checkboxRates = $('.list-rates');

$checkboxRates.each(function() {
	let $this = $(this);
	let $checkboxRatesInput = $this.find('input');
	let ratesLength = $checkboxRatesInput.closest('li').length;

	$checkboxRatesInput.on('change', function() {
		let starValue = $(this).attr('value');

		for (let i = 0; i <= ratesLength; i++) {
			if (i <= starValue) {
				$this
					.find('li')
					.eq(i - 1)
					.addClass('selected')
					.find('input')
					.prop('checked', true);
			} else {
				$this
					.find('li')
					.eq(i - 1)
					.removeClass('selected')
					.find('input')
					.prop('checked', false);
			}
		}
	});
});

/**
 * Trigger player on click.
 */
function triggerPlayer($player) {
	$player.each(function() {
		var $parent = $(this).closest('.js-video-holder');

		var playerWrapper = new YouTubePlayer(this, {
			onPlayerStateChange: function(event) {
				if (event.data === 0) {
					playerWrapper.play();
				}

				if (event.data === 3) {
					setTimeout(function() {
						$parent.addClass('played');
					}, 105);
				}

				if (event.data === 2) {
					setTimeout(function() {
						$parent.removeClass('played');
					}, 100);
				}
			}
		});

		playerWrapper.onReady = function() {
			this.play();
		};
	});
}

triggerPlayer($('.wrapper .youtube-player'));

// Light Gallery

$('.js-lightvideo-init').lightGallery({});

$('.js-animated-thumbnials').lightGallery({
	thumbnail: true,
	download: false,
	selector: '.js-lightbox-item'
});

$('.js-gallery-items').each(function() {
	const $gallery = $(this);

	$gallery.lightGallery({
		thumbnail: true,
		download: false,
		selector: '.js-gallery-item'
	});
});

$('.js-trigger-gallery').on('click', function(event) {
	event.preventDefault();

	$(this)
		.closest('.product--detailed')
		.find('.product__gallery .js-lightbox-item:first-child')
		.click();
});

// Equalize Height Functionality
$.fn.equalizeHeight = function() {
	var maxHeight = 0,
		itemHeight;

	for (var i = 0; i < this.length; i++) {
		itemHeight = $(this[i])
			.height('auto')
			.height();
		if (maxHeight < itemHeight) {
			maxHeight = itemHeight;
		}
	}

	return this.height(maxHeight);
};



// WEBPACK FOOTER //
// ./../src/assets/js/main.js